<template>
  <page>
    <module enable-flex ref="view">
      <m-search ref="search" @search="searchHandle">
        <c-form>
          <c-form-item type="input" label="提现单号" name="apply_number"></c-form-item>
          <c-form-item type="datetime" label="申请时间" start-name="begin_time" end-name="end_date"></c-form-item>
          <c-form-item type="input" label="代理昵称" name="nick_name"></c-form-item>
          <c-form-item type="input" label="代理手机号" name="phone"></c-form-item>
          <c-form-item type="input" label="提现账号" name="bank_card"></c-form-item>
          <c-form-item type="select" label="到账渠道" name="withdraw_channel" :options="withdrawChannel"></c-form-item>
          <c-form-item type="checkbox" label="状态" name="state" :options="stateOptions"></c-form-item>
        </c-form>
      </m-search>
      <m-operate>
<!--        <c-button color="m" power="b_member_account_extract_approval" @click="batchApproval(2)">批量审批通过</c-button>-->
        <c-button color="m" hollow @click="syncExport()">导出</c-button>

        <template #right>
          <c-button v-if="userInfo.id == 1" color="red" @click="$refs.view.editExportColumn(workType)">编辑导出列</c-button>
        </template>
      </m-operate>
      <c-table ref="table">
        <c-table-column type="selector"></c-table-column>

        <c-table-column
            label="提现账户"
            name="account_type"
            width="80"
        >
          <template v-slot="{data}">
            <span style="color:coral" v-if="data.account_type==1">资金账户</span>
            <span style="color:blue" v-if="data.account_type==2">收益账户</span>
          </template>
        </c-table-column>

        <c-table-column
            label="提现单号"
            name="apply_number"
            width="130"
        ></c-table-column>

        <c-table-column
            label="状态"
            name="state"
            width="80"
        >
          <template v-slot="{data}">
            <span style="color:coral" v-if="data.state==1">{{ stateName[data.state] }}</span>
            <span style="color:dodgerblue" v-if="data.state==2">{{ stateName[data.state] }}</span>
            <span style="color:brown" v-if="data.state==3">{{ stateName[data.state] }}</span>
            <span style="color:green" v-if="data.state==4">{{ stateName[data.state] }}</span>
            <span style="color:red" v-if="data.state==5">{{ stateName[data.state] }}</span>
            <span style="color:gray" v-if="data.state==10">{{ stateName[data.state] }}</span>
          </template>
        </c-table-column>

        <c-table-column
            label="代理手机号"
            name="user_manage_mobilephone"
            width="120"
        ></c-table-column>

        <c-table-column
            label="代理头像/昵称"
            name="head_photo"
            width="140"
        >
          <template v-slot="{data}">
            <div class="flex-center-cross">
              <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
              <span>{{ data.nick_name || '--' }}</span>
            </div>
          </template>
        </c-table-column>

        <c-table-column
            label="提现申请金额"
            name="original_extract_money"
            width="110"
        >
          <template v-slot="{data}">
            <span style="color:dodgerblue"
                  v-if="data.original_extract_money && data.original_extract_money>0">￥{{ data.original_extract_money.toFixed(2) }}</span>
            <span v-else>--</span>
          </template>
        </c-table-column>

        <c-table-column
            label="预计到账金额"
            name="extract_money"
            width="110"
        >
          <template v-slot="{data}">
            <span style="color:dodgerblue"
                  v-if="data.extract_money && data.extract_money>0">￥{{ data.extract_money.toFixed(2) }}</span>
            <span v-else>--</span>
          </template>
        </c-table-column>

        <c-table-column
            label="提现手续费"
            name="withdraw_fee"
            width="90"
        >
          <template v-slot="{data}">
            <span style="color:dodgerblue"
                  v-if="data.withdraw_fee && data.withdraw_fee>0">￥{{ data.withdraw_fee.toFixed(2) }}</span>
            <span v-else>--</span>
          </template>
        </c-table-column>

        <c-table-column
            label="申请时间"
            name="apply_date"
            width="140"
        ></c-table-column>

        <c-table-column
            label="提现账号"
            name="withdraw_account_number"
            width="250"
        >
          <template v-slot="{data}">
            {{ withdrawAccountNumber(data) }}
          </template>
        </c-table-column>

        <c-table-column
            label="备注"
            name="remark"
            width="200"
        ></c-table-column>

        <c-table-column
            label="审批时间"
            name="audit_date"
            width="150"
        >
          <template v-slot="{data}">
            <span v-if="data.audit_date">{{ data.audit_date }}</span>
            <span v-else>--</span>
          </template>
        </c-table-column>

        <c-table-column
            label="审批人姓名"
            name="audit_user_realname"
        >
          <template v-slot="{data}">
            <span v-if="data.audit_user_realname">{{ data.audit_user_realname }}</span>
            <span v-else>--</span>
          </template>
        </c-table-column>

        <c-table-column
            label="打款时间"
            name="playmoney_date"
            width="150"
        >
          <template v-slot="{data}">
            <span v-if="data.playmoney_date">{{ data.playmoney_date }}</span>
            <span v-else>--</span>
          </template>
        </c-table-column>

        <c-table-column
            label="打款人姓名"
            name="playmoney_user_realname"
        >
          <template v-slot="{data}">
            <span v-if="data.playmoney_user_realname">{{ data.playmoney_user_realname }}</span>
            <span v-else>--</span>
          </template>
        </c-table-column>

        <c-table-column
            type="button"
            fixed="right"
            label="操作"
            width="115"
        >
          <template v-slot="{data}">
            <c-table-button @click="navigateTo(`/member_account_extract_detail/${data.id}`)">查看</c-table-button>
            <c-table-button v-if="data.state == 1" power="b_member_account_extract_approval" @click="navigateTo(`/member_account_extract_detail/${data.id}`)">审批</c-table-button>
            <c-table-button v-if="data.state == 2 && (auth('b_member_account_extract_pay') || (auth('b_member_account_extract_approval') && systemConfig.withdrawal_auto_pay == 'ON'))"
                            @click="navigateTo(`/member_account_extract_detail/${data.id}`)">打款
            </c-table-button>
          </template>
        </c-table-column>
      </c-table>
    </module>

  </page>
</template>

<script>
import {mapGetters} from 'vuex'
import {mapState} from "vuex";  // 代理库

export default {
  name: 'm_member_account_extract',

  computed: {
    ...mapState(['systemConfig', 'userInfo']),
    ...mapGetters({
      auth: 'power'
    }),
    //提现状态
    stateOptions() {
      return (
          [{
            name: '待审批',
            value: 1
          }].concat([{
            name: '待打款',
            value: 2
          }])
          .concat(this.systemConfig.withdrawal_auto_pay == 'ON' ? [{
            name: '待到账',
            value: 3
          }] : [])
          .concat([{
            name: '打款到帐',
            value: 4
          }])
          .concat(this.systemConfig.withdrawal_auto_pay == 'ON' ? [{
            name: '打款失败',
            value: 5
          }] : [])
          .concat([{
            name: '审批驳回',
            value: 10
          }])
      );
    }
  },

  data() {
    return {
      workType: 5,
      searchParams: {},
      stateName: {
        1: '待审批',
        2: '待打款',
        3: '待到账',
        4: '打款到帐',
        5: '打款失败',
        10: '审批驳回'
      },
      withdrawChannel: [
        {name: '全部', value: 0},
        {name: '银行卡', value: 1},
        {name: '支付宝', value: 2},
        {name: '微信', value: 3}
      ]
    }
  },

  mounted() {
    this.$refs.search.search();
    this.$bus.$on('member_account_extract.update', data => {
      // 刷新列表
      this.$refs.table.update();
    });

  },

  methods: {
    searchHandle(data) {
      this.$refs.table.load({
        url: '/user/extract/list',
        data
      });
      this.searchParams = data || {};
    },

    withdrawAccountNumber(data) {
      if (data.withdraw_channel == 1) {
        // return '【银行卡】'+data.bank_card + '（开户行：' + data.bank_name + '/持卡人：' +  data.account_name + '）';
        return '【银行卡】' + data.bank_card + '（持卡人：' + data.account_name + '/电话：' + data.phone + '）';
      } else if (data.withdraw_channel == 2) {
        return '【支付宝】' + data.withdraw_account_number;
      } else if (data.withdraw_channel == 3) {
        return '【微信】' + data.withdraw_account_number;
      } else if (data.withdraw_channel == 4) {
        return '【平台账户】';
      } else {
        return '--'
      }
    },
    /**
     * 批量审批提现申请
     * @param state  2=审批通过
     * @returns {boolean}
     */
    batchApproval(state) {
      //批量操作
      var list = this.$refs.table.getRow('selected');
      if (!list.length) {
        this.$message({
          text: '请选择要处理的申请记录'
        });
        return;
      }
      var flag = true;
      list.forEach((item, index, array) => {
        if (item.data.state != 1) {
          flag = false;
        }
      });
      if (!flag) {
        this.$message({
          text: '只能选择【待审批】的申请记录进行操作！'
        });
        return false;
      }
      var ids = Array.from(list, item => {
        return item.data.id;
      })
      this.$confirm({
        text: '是否确认将已选中的【' + ids.length + '】提现记录审批通过？',  // 提示内容,
        buttonName: '确认审批通过',  // 确定按钮文字
        cancelButton: true,  // 是否显示取消按钮
        resolve: () => {
          this.request({
            url: '/user/extract/approval',
            data: {ids: ids, state: state},
            loading: true,
            success: data => {
              this.$message({
                text: '审批通过成功',
                icon: 'success'
              });
              //刷新列表
              this.$refs.table.update();
            }
          });
        },  // 确定按钮回调
        cancel: () => {
        },  // 取消按钮回调
      });
    },
    /**
     * 同步导出数据
     * @param work_type
     */
    /**同步导出数据*/
    syncExport() {
      var selectDatas = this.$refs.table.getRow('selected');
      var ids = [];
      if (selectDatas.length && selectDatas.length > 0) {
        ids = Array.from(selectDatas, item => item.data.id);
      }
      this.export(this.workType, this.searchParams, ids);
    }
  }
}
</script>